import React from 'react';
import { connect } from 'react-redux';

import { confirmEmail } from '../../../../redux/auth/emailConfirmation/actions';
import { updateQueryString } from '../../../../redux/router/actions';

import EmailConfirmationModal from './EmailConfirmationModal';

import * as selectors from './selectors';

const EmailConfirmationModalConnected = (props) => <EmailConfirmationModal {...props} />;

const mapStateToProps = (state) => ({
  activated: selectors.selectActivated(state),
  error: selectors.selectError(state),
  errorMessage: selectors.selectErrorMessage(state),
  isLoading: selectors.selectIsLoading(state),
  isVisible: selectors.selectIsVisible(state),
});

const mapActionsToProps = {
  confirmEmail,
  updateQueryString,
};

export default connect(mapStateToProps, mapActionsToProps)(EmailConfirmationModalConnected);
